import React from "react";
import banner from "../assets/banner1.jpg";

export default function NdomanoCapital() {
  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
           <div className="col-md-6 text-center">
            <img src={banner} alt="Ndomano Capital" className="img-fluid rounded" style={{maxHeight: '320px', objectFit: 'cover'}} />
          </div>
          <div className="col-md-6">
            <h2 className="main-section-title">Ndomano Capital (T) LTD</h2>
            <p className="text-muted">
              Ndomano Capital empowers growth through smart finance. We provide strategic financial solutions tailored for individuals, small and medium enterprises, and emerging ventures across Tanzania. Our services include microfinance lending, investment advisory, and tailored credit products designed to unlock opportunities for sustainable growth.
            </p>
            <p className="text-muted">
              Built to support entrepreneurs and communities, Ndomano Capital blends modern digital processes with local market expertise to deliver fast, transparent, and responsible financial services. We partner with stakeholders to ensure access to capital that drives economic inclusion and business resilience.
            </p>
            <div className="my-3">
              <a className="btn btn-primary" href="https://ndomanocapital.com" target="_blank" rel="noreferrer">Visit Ndomano Capital</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
